import { api } from '@services';
import { Convert } from '@utils';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/RECEPTION') => `${reducer}/${actionType}`;

export const sendType = (symbol = '', value = '') => {
	return async (dispatch, getState) => {
		const turnType = getState().page.reception.selectService.type;
		const onOK = async (res) => {
			const data = res.info || null;
			const firstName = data.NAME || '';
			const nationalCode = data.NATIONALNUMBER || '';
			const date = data.PERSIANDATE.split(' ')[0];
			const time = data.PERSIANDATE.split(' ')[1];

			await await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					step: 'completed',
					completed: {
						...getState().page.reception.completed,
						firstName,
						nationalCode,
						date,
						time,
					},
				},
			});
		};

		const onFail = async (res) => {
			// await dispatch({
			// 	type: generateType('CUSTOM'),
			// 	payload: {
			// 		...getState().page.adminSetting,
			// 	},
			// });
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					_status: status,
				},
			});
		};

		api.$turn_rating({ onOK, onFail, onStatus }, { TurnType: turnType });
	};
};

export const getDate = (symbol = '', value = '') => {
	return async (dispatch, getState) => {
		const date = getState().page.reception.selectDate.date || '';

		const onOK = async (res) => {
			const $timesList = res.info || [];
			const reservableList = $timesList.filter((item) => !item?.CUSTOMER_ID);
			const reservableCount = $timesList.length ? reservableList.length : 0;

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					selectDate: {
						...getState().page.reception.selectDate,
						$timesList,
						reservableCount,
					},
				},
			});
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					selectDate: {
						...getState().page.reception.selectDate,
						_timesList: status,
					},
				},
			});
		};

		api.$turn_getDate({ onOK, onFail, onStatus }, { date: +Convert.newDateToFaDate(date) });
	};
};

export const sendOtp = (symbol = '', value = '') => {
	return async (dispatch, getState) => {
		const cellphone = +getState().page.reception.form.personalInfo.cellphone || '';

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					step: 'checkOtp',
				},
			});
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					form: {
						...getState().page.reception.form,
						_form: status,
					},
				},
			});
		};

		api.$otp_send_customer({ onOK, onFail, onStatus }, { cellphone });
	};
};

export const turnTake = (symbol = '', value = '') => {
	return async (dispatch, getState) => {
		const reception = getState().page?.reception || {};
		const form = reception?.form || {};
		//
		const address = form?.personalInfo?.address || null;
		const amount = +form?.transactionInfo?.amount || null;
		const birthDate = form?.personalInfo?.birthDate ? Convert.newDateToFaDate(form?.personalInfo?.birthDate) : null;
		const birthPlace = form?.personalInfo?.birthPlace || null;
		const cellphone = +form?.personalInfo?.cellphone || null;
		const code = +reception?.checkOtp?.code || null;
		const currency = form?.transactionInfo?.currency?.value || null;
		const gender = form?.personalInfo?.gender?.value || null;
		const phone = +form?.personalInfo?.phone || null;
		const name = form?.personalInfo?.name || null;
		const lastName = form?.personalInfo?.lastName || null;
		const nationalNumber = form?.personalInfo?.nationalNumber || null;
		const nationality = form?.personalInfo?.nationality || null;
		const postalCode = +form?.personalInfo?.postalCode || null;
		const turnId = +reception?.selectDate?.turnId || null;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					step: 'completed',
				},
			});
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.reception,
					checkOtp: {
						...getState().page.reception.checkOtp,
						_checkOtp: status,
					},
				},
			});
		};

		api.$turn_take(
			{ onOK, onFail, onStatus },
			{
				address,
				amount,
				birthDate,
				birthPlace,
				cellphone,
				code,
				currency,
				gender,
				phone,
				lastName,
				name,
				nationalNumber,
				nationality,
				postalCode,
				turnId,
			},
		);
	};
};
